import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currFile_name: '',
};

const fileNameSlice = createSlice({
  name: 'currFile_name',
  initialState,
  reducers: {
    setCurrFileName: (state, action) => {
      state.currFile_name = action.payload;
    },

  }
});

export const { setCurrFileName } = fileNameSlice.actions;
export default fileNameSlice.reducer;